export default function(collection, newField) {
  return {
    array: [...collection, {
      ...newField,
      isAddedByUser: true
    }]
  }
}
